// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import building05Icon from "@/assets/icons/building-05.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Building05IconProps = Omit<IconProps, "name">;

export function Building05Icon(props: Building05IconProps): React.ReactNode {
  return <Icon name={building05Icon} {...props} />;
}
